var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95423 0.85778C4.413 0.0421984 5.58725 0.042198 6.04602 0.85778L9.3942 6.8101C9.84416 7.61003 9.2661 8.59842 8.34831 8.59842H1.65194C0.734151 8.59842 0.156094 7.61003 0.606052 6.81011L3.95423 0.85778ZM5.60007 6.79849C5.60007 7.12986 5.33144 7.39849 5.00007 7.39849C4.6687 7.39849 4.40007 7.12986 4.40007 6.79849C4.40007 6.46712 4.6687 6.19849 5.00007 6.19849C5.33144 6.19849 5.60007 6.46712 5.60007 6.79849ZM5.00007 1.99849C4.6687 1.99849 4.40007 2.26712 4.40007 2.59849V4.39849C4.40007 4.72986 4.6687 4.99849 5.00007 4.99849C5.33144 4.99849 5.60007 4.72986 5.60007 4.39849V2.59849C5.60007 2.26712 5.33144 1.99849 5.00007 1.99849Z",
    fill: "#FBBF24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowAlert);
export default __webpack_public_path__ + "static/media/YellowAlert.87b2a1a15d4c5fef21b4a74a74046f6d.svg";
export { ForwardRef as ReactComponent };